import { gsap } from "gsap/all";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { Observer } from "gsap/Observer";

gsap.registerPlugin((ScrollTrigger, Observer));
//
//
// GSAP DEFAULTS SEETIS
///  ------ ------ ------ ------ ------ ------ ------ ------ ------ ------
var markers = false;
gsap.config({
  nullTargetWarn: false,
});
gsap.defaults({
  ease: "none",
});
ScrollTrigger.config({
  limitCallbacks: true,
  immediateRender: false,
  ignoreMobileResize: true,
  normalizeScroll: true,
});

import { Application } from "@splinetool/runtime";

export function makeSpline(page) {
  if (page == "homepage" || page == "contact")
    if (document.getElementById("canvas3d")) {
      const canvas = document.getElementById("canvas3d");

      ANIM.canvas = gsap
        .timeline({
          paused: true,
          defaults: { ease: "power4.out", duration: 0.7 },
        })
        .set(canvas, {
          opacity: 0,
        })
        .to(
          canvas,

          {
            opacity: 1,
          }
        );
      const spline = new Application(canvas);

      spline
        .load(
          "https://prod.spline.design/TA2eLHoHzvLRPlW9/scene.splinecode",

          {
            credentials: "include",
            mode: "cors",
          }
        )
        .then(() => {
          var sudop = spline.findObjectByName("sudop");
          ANIM.canvas.play();

          var splineAnim = gsap
            .timeline({
              defaults: { ease: "none", duration: 1 },

              scrollTrigger: {
                trigger: canvas,

                start: "top bottom",
                toggleActions: "play none none none",
                end: "bottom top",
                markers: false,
                once: false,
                scrub: true,
              },
            })

            .to(
              sudop.rotation,

              {
                y: sudop.rotation.y + Math.PI * 0.2,
              },
              "<"
            );

          ScrollTrigger.create({
            trigger: "[data-hero-perex]",
            start: "top center",
            markers: false,
            once: true,
            end: "bottom top",

            onUpdate: (self) => {},
          });
        });
      /********************************************* WHEN READY START ANIMATION  ****************************** */
      const canvas2 = document.getElementById("canvas3d2");
      if (canvas2) {
        const spline = new Application(canvas2);

        spline
          .load(
            "https://prod.spline.design/J7j37NlSomrmL3Zv/scene.splinecode",

            {
              credentials: "include",
              mode: "no-cors",
            }
          )
          .then(() => {
            var trigger = spline.findObjectByName("trigger");
            var start = "top bottom";
            new gsap.timeline({
              defaults: { ease: "none", duration: 1 },

              scrollTrigger: {
                trigger: canvas2,
                start: start,
                toggleActions: "play none none none",
                end: "bottom top",
                markers: false,
                once: false,
                scrub: true,
              },
            }).to(
              trigger.rotation,

              {
                y: trigger.rotation.y + Math.PI * 0.2,
              },
              "<"
            );

            ScrollTrigger.create({
              trigger: canvas2,
              start: start,
              markers: false,
              once: true,
              end: "bottom top",
              onEnter: (self) => {
                gsap.to(canvas2, {
                  autoAlpha: 1,
                  duration: 0.5,
                  onComplete: () => {
                    canvas2.classList.add("ready");
                  },
                });
              },
              onUpdate: (self) => {},
            });
          });
      }
    }
  /********************************************* WHEN READY START ANIMATION  ****************************** */
  const canvas3 = document.getElementById("canvas3d3");
  if (canvas3) {
    const spline = new Application(canvas3);

    spline
      .load(
        "https://prod.spline.design/h94N9NnwmwHSIsnn/scene.splinecode",

        {
          credentials: "include",
          mode: "no-cors",
        }
      )
      .then(() => {
        var item1 = spline.findObjectByName("item1");
        var item2 = spline.findObjectByName("item2");
        // var item2 = spline.findObjectByName("item2");
        var start = "top bottom";
        new gsap.timeline({
          defaults: { ease: "none", duration: 1 },

          scrollTrigger: {
            trigger: canvas3,
            start: start,
            toggleActions: "play none none none",
            end: "bottom top",
            markers: false,
            once: false,
            scrub: true,
          },
        })
          .to(
            item1.rotation,

            {
              y: item1.rotation.y + Math.PI * 0.1,
            },
            "<"
          )
          .to(
            item2.rotation,

            {
              z: item2.rotation.z + Math.PI * 0.52,
            },
            "<"
          );

        ScrollTrigger.create({
          trigger: canvas3,
          start: start,
          markers: false,
          once: true,
          end: "bottom top",
          onEnter: (self) => {
            gsap.to(canvas3, {
              autoAlpha: 1,
              duration: 0.5,
              onComplete: () => {
                canvas3.classList.add("ready");
              },
            });
          },
          onUpdate: (self) => {},
        });
      });
  }

  /********/
  const canvas4 = document.getElementById("canvas3d4");
  if (canvas4) {
    const spline = new Application(canvas4);

    spline
      .load(
        "https://prod.spline.design/SJa2GMYCr97ZwuVl/scene.splinecode",

        {
          credentials: "include",
          mode: "no-cors",
        }
      )
      .then(() => {
        var items = spline.findObjectByName("items");

        // var item2 = spline.findObjectByName("item2");
        var start = "top bottom";
        new gsap.timeline({
          defaults: { ease: "none", duration: 1 },

          scrollTrigger: {
            trigger: canvas4,
            start: start,
            toggleActions: "play none none none",
            end: "bottom top",
            markers: false,
            once: false,
            scrub: true,
          },
        }).to(
          items.rotation,

          {
            y: items.rotation.y + Math.PI * 0.1,
          },
          "<"
        );

        ScrollTrigger.create({
          trigger: canvas3,
          start: start,
          markers: false,
          once: true,
          end: "bottom top",
          onEnter: (self) => {
            gsap.to(canvas4, {
              autoAlpha: 1,
              duration: 0.5,
              onComplete: () => {
                canvas4.classList.add("ready");
              },
            });
          },
          onUpdate: (self) => {},
        });
      });
  }
}
/********************************************* WHEN READY START ANIMATION  ****************************** */
